import React from "react";

const NotFound = () => {
    return (
        <div style={{ height: "100vh" }} className="container">
            <h2>404 <br />
                Page Not Found</h2>
        </div>
    );
};

export default NotFound;
